import React from 'react';
import { Row } from 'react-bootstrap';
import CustomWidget from '../Custom/CustomWidget';
import ChartEnergyBudgetForecast from './Charts/ChartEnergyBudgetForecast';

const TabForecast = ({ hirarchy }) => (
  <Row>
    <CustomWidget
      size={12}
      id={'chrtEnergyBudget'}
      title={'Energy Budget Forecast'}
    >
      <ChartEnergyBudgetForecast
        type={hirarchy.type.label}
        id={hirarchy.level.value}
      />
    </CustomWidget>
  </Row>
);

export default TabForecast;
